

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import store from '../store/index.js';
export default {
    data(){
        return {
            imgList: [{
                    url: require('../../assets/scence.jpg'),
                    text: '图片1'
                },
                {
                    url: require('../../assets/scence.jpg'),
                    text: '图片2'
                },
                {
                    url: require('../../assets/scence.jpg'),
                    text: '图片3'
                }
            ],
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                    // type: 'fraction'
                }
            }
        }
    },
    components: {
	    swiper,
	    swiperSlide
	},
}
</script>
<template>
  <div class="wrap">
      <h3 class="title">精彩现场</h3>
      <div class="main">
          <swiper :options="swiperOptions">
              <swiper-slide v-for="img in imgList" :key="img.title">
                  <img :src="img.url" width="100%" :alt="img.title">
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
      </div>
  </div>
</template>
<style lang="stylus" scoped>
.wrap
    margin-bottom 1rem 
    .title
        margin 0.5rem auto
        position relative
        width 6.72rem
        text-indent 2.05rem
        &:before
            content ''
            position absolute
            left 0.7rem
            top .26rem
            width 1.01rem
            height 1.07rem
            background url("../../assets/title_jcxc_bg.svg") no-repeat
            background-size 100%
        &:after
            content ''
            display inline-block
            position absolute
            left 0
            bottom 0
            width 100%
            height 0.11rem
            background url("../../assets/title_line.png") top left no-repeat
            background-size 100%
    .main
        margin: 0 auto
        width 17.33rem
        height 10.83rem
        border-radius 0.27rem
        img 
            width 100%
            height 10.83rem
            border-radius 0.27rem
    >>>.swiper-pagination
    //     text-align right
    //     font-size 20px
    //     .swiper-pagination-total
    //         padding-right .5rem
        .swiper-pagination-bullet
            width 0.32rem
            height 0.32rem
            background #ffffff
            opacity 1
        .swiper-pagination-bullet-active
            // background #007aff
            width 2.45rem
            border-radius 0.16rem

</style>